export interface Option {
  value: string;
  title: string;
}

export interface PlatformProductFields {
  platformOptionsLabel: string;
  platformAI: string;
  platformExpiry: string;
  platformDonationsBusiness?: string;
  platformDonationsCharity?: string;
  platformConsumer: string;
  platformOptionsValidationMessage: any;
}

export interface SalesforceFieldsTexts {
  firstNameLabel: string;
  firstNamePlaceholder: string;
  lastNameLabel: string;
  lastNamePlaceholder: string;
  emailLabel: string;
  emailPlaceholder: string;
  companyLabel: string;
  companyPlaceholder: string;
  phoneLabel: string;
  phonePlaceholder: string;
  websiteLabel?: string;
  websitePlaceholder?: string;
  optInNewsletter: string;
  noteText?: string;
  productInterest: string;
  platformOption: PlatformProductFields;
  [key: string]: unknown;
}

export interface SalesforceBlockerInputTexts {
  blockerTitle: string;
  blockerDescription?: string;
  userBlockerOptionTitle: string;
  businessBlockerOptionTitle: string;
  blockerValidationMessage?: string;
}

export enum CampaignParams {
  utm_campaign = 'utmCampaign',
  utm_medium = 'utmMedium',
  utm_source = 'utmSource',
  utm_content = 'utmContent',
  utm_term = 'utmTerm',
  optInNewsletter = 'optInNewsletter',
  optInPrivacyPolicy = 'optInPrivacyPolicy',
  acceptedMarketingCookies = 'acceptedMarketingCookies',
  facebook_click_id = 'facebookClickId',
  gclid = 'googleClickId',
  locale = 'locale',
  productInbound = 'productInterest',
}

export interface SalesforceFormValues {
  blockerInput?: any | null;
  firstName?: string;
  lastName?: string;
  emailAddress?: string;
  companyName?: string;
  phoneNumber?: string;
  countryCode?: string;
  utmCampaign?: string;
  utmMedium?: any;
  utmSource?: any;
  utmContent?: string;
  utmTerm?: string;
  optInNewsletter?: boolean | Number;
  optInPrivacyPolicy?: boolean | Number;
  acceptedMarketingCookies?: boolean | Number;
  facebookClickId?: string;
  googleClickId?: string;
  locale?: string;
  productInbound?: string;
  websiteName?: string;
  platformProduct?: string;
}
